import { useMutation, useQueryClient } from "@tanstack/react-query";

import { voidPayment } from "api/payment.api";
import {
  invalidateDashboardSources,
  invalidatePaymentSide,
} from "lib/cacheInvalidation";

export const useVoidPayment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, reason }) => voidPayment(id, { reason }),
    onSuccess: () => {
      invalidatePaymentSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
